export const helperTexts = {
    sensorAlertsTab: {
        alertThreshold: "Update alert threshold by slider",
        speedometer: `Average Corrosion Rate for selected time period,
                      Red: Average CR above the threshold,
                      Yellow: Average CR about to reach the threshold,
                      Green: Average CR is optimal`,
        alertReport: "Select start and end date to get alerts report."
    },

    CrAlertsTable: {
        amber: 'CRavg is ≥ 90% of set threshold',
        red: 'CRavg is ≥ set threshold'
    },

    sensorCrDetails: {
        longCR: "Average predicted corrosion rate for entire duration",
        shortCR: "Average predicted Corrosion rate of 6 month period before last predict date",
        realCR: "Last Non Zero Predicted Corrosion Rate from the model",
        customCR: "Average predicted corrosion rate from start and end date selected below",
        wtLoss: "a) Wall thickness loss was calculated only for the selected duration, if the selected dates fall within the prediction duration. \n b) If the start date is earlier than the prediction start date, the model will use the prediction start date to calculate wall thickness loss.\n c) If the end date is later than the last prediction date, the model will use the last prediction date to calculate wall thickness loss."
    },

    sensorFeatureAnalysis: {
        featurePlot:
            "Play area for trying out different input features expecting CARMA prediction to compare the variation in results. ",
        resetHelp: "The default date (missing features < 70 %) will be displayed here. To analyze data from a previous date, select the new date and click the update button. Click the reset option to return to the default date data."
    },

    sensorInfo: {
        noSensorRating: "Rating is calculated by considering the difference between Measured WT calculated from SCR/ACR and predicted WT, and comparing them with thresholds to come up with final rating of how good is model performing. SCR (Suggested CR) is imported from IMS",
        sensorRating: "Rating is calculated by considering the difference between Measured WT and predicted WT, and comparing them with thresholds to come up with final rating of how good is model performing.",
        norco: "Rating is calculated by considering the difference between Measured WT calculated from ACR (Actual Measured CR) and predicted WT, and comparing them with thresholds to come up with final rating of how good is model performing. ACR is calculated based on the actual measured WT from IMS"
    },

    infoPanel: {
        CurrentWallThickness: "Last Predicted Wall thickness derived from predicted Corrosion Rates (Last date when wall thickness was derived from predicted Corrosion Rates)",
        CurrentCorrosionRates: "Last Predicted Corrosion Rate from the model (Last date when Corrosion Rate was predicted from the model)",
        AverageCorrosionRate: "Average of Predicted Corrosion Rates in the past 100 days",
        ExpectedEOF: "The year when the CML reaches the minimum required wall thickness based on the real-time corrosion rate (CR) and current wall thickness.",
    },

    cmlInfo: {
        CurrentAvgCr: "Average last predicted corrosion rates of all sensors under this corrosion monitoring location",
        CurrentAvgWT: "Average last predicted wall thickness of all sensors under this corrosion monitoring location"
    },

    clInfo: {
        CurrentAvgCr: "Average last predicted corrosion rates of all sensors under this corrosion loop",
        CurrentAvgWT: "Average last predicted wall thickness of all sensors under this corrosion loop"
    },
    topContributor: {
        replicationInfo: `Since it was a replication model, both "Lifetime" & "Last 6 Month" Top Contributor feature data are based on the model training features data instead of actual sensor/ asset data.`
    },

    modelTraining: {
        modelName: "Model Name is the unique identifier for the model. It should be descriptive and reflect the purpose of the model",
        subject: "Select the column that maps to the Unique Sensor/CML id column",
        timestamp: "Select the column that maps to the Date/Time column",
        target: "Select the column that maps to the MeasuredCR/MeasuredWT column that the model will predict after training",
        features: "Select the columns that maps to the feature/process parameter columns to train the model",
        model: "Select XGB(XGBoost) for complex datasets requiring high accuracy due to its advanced regularization techniques. Select LGBM(LightGBM) for large datasets needing faster training and lower memory usage due to its histogram-based approach.",
        select: "Select Sensor/CMLs for the model performance from the below list",
        trainPeriod: "In order to select the training period within the period of uploaded data, picker is disabled outside the data range",
    }
}

export const DE_INSTALL_HELP = {
    bukam: "The sensor is not fetching any thickness values currently",
    other: "sensor is de-installed",
};

export const DE_INSTALLED_PROD_UNIT = "S901-CD5";